import { defaultStoreUtils } from '@databases/redux';
import { getMediaCollectionId } from '@databases/utils/media-client';
import { useCallback, useEffect, useState } from 'react';

/**
 * Hook for managing media collection ID
 */
export const useMediaCollectionId = (contentId: string) => {
  const [mediaCollectionId, setMediaCollectionId] = useState<string | null>(null);
  const store = defaultStoreUtils.useStore();

  const getCollectionId = useCallback(async () => {
    const id = await getMediaCollectionId(store.getState(), contentId);
    if (id) {
      setMediaCollectionId(id);
    }
  }, [contentId, store]);

  useEffect(() => {
    getCollectionId();
  }, [getCollectionId]);

  return {
    mediaCollectionId,
  };
};
